import React from 'react';

import EmptyState from '../common/EmptyState';
import { PLUS } from '../icons';
import { WATCH_HOW_VIDEOS } from '../../config/watchHowVideos';

/**
 * A card with no elements yet, in the card editor's Elements tab (KPE-009).
 * Its own file so the editor never grows to carry the copy or the Watch how
 * wiring (KPR-1929).
 */
export default function NoElementsEmptyState({ onAdd }) {
	return (
		<EmptyState
			data-testid="no-elements-empty-state"
			title="No elements yet"
			description={[
				'An element is one field on the card, of a set type such as text, date or number.',
				'Add one to start shaping what each record holds.',
			]}
			primaryAction={{ label: 'Add element', icon: <PLUS />, onClick: onAdd }}
			learnMore="cards-and-elements/add-an-element"
			video={WATCH_HOW_VIDEOS.noElements}
		/>
	);
}
